export const E3M3_TO_MCF = 35.314667;
export const E3M3_TO_MMBTU = 35.31073446;
export const E3M3_TO_BOE = 6.046;
export const MMBTU_TO_BOE = 0.1781;
export const M3_TO_BBL = 6.289814;
export const M_TO_FT = 3.28084;
export const MONTH_LENGTH = 30.436875;
export function f_TO_C(value) {return (value - 32) * (5 / 9)}; // fahrenheit to celsius
export function c_TO_F(value) {return (value * 1.8) + 32}; // celsius to fahrenheit
